export type Cadence='day'|'week'|'month';
export type ActivityPeriod={period:string;interactions:number;inquiries:number;calls:number;forms:number};
export const cadenceLabels:Record<Cadence,string>={day:'Daily',week:'Weekly',month:'Monthly'};
export function easternToday(now=new Date()):string{
 const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
 return ['year','month','day'].map(k=>parts.find(p=>p.type===k)!.value).join('-');
}
export function lookbackRange(value:string,today=easternToday()):[string,string]{
 if(value==='all')return ['',''];
 if(value==='month')return [today.slice(0,8)+'01',today];
 const days=Number(value);const d=new Date(today+'T12:00:00Z');d.setUTCDate(d.getUTCDate()-days+1);
 return [d.toISOString().slice(0,10),today];
}
export function activityAverage(periods:ActivityPeriod[],key:'interactions'|'inquiries'|'calls'|'forms'):number{
 return periods.length?periods.reduce((sum,p)=>sum+p[key],0)/periods.length:0;
}
export function periodLabel(value:string,cadence:Cadence):string{
 const date=new Date(value+'T12:00:00Z');
 const label=date.toLocaleDateString('en-US',{timeZone:'UTC',...(cadence==='month'?{month:'short',year:'numeric'}:{month:'short',day:'numeric',year:'numeric'})});
 return cadence==='week'?'Week of '+label:label;
}

